// Texto de ayuda del permiso de montos de usuarios de sede (alta y edición)
export const VER_MONTOS_TOOLTIP =
    'Este permiso es a nivel de la sede: al cambiarlo se aplica a todos los usuarios de esta sede, no solo a este usuario.';
